// Module
var code = "<vsko-loading-bar></vsko-loading-bar> <my-cookies-modal complete-cookies=\"ctrl.setCookies\"></my-cookies-modal> <div class=\"content\" ui-view></div> ";
// Exports
module.exports = code;